type CalibrationStatusMap = Record<string, string>;

const renderCalibrationStatus = (statusMap: CalibrationStatusMap) => (value: unknown) => {
  const status = statusMap[String(value)];

  return status ?? value;
};

export const renderYuanzhiyunCalibrationStatus = renderCalibrationStatus({
  0: '未开始',
  1: '相机参数配置完成',
  2: '雷达参数配置完成',
  3: '车道线信息读取中',
  4: '雷达标定完成',
  5: '相机静态标定完成',
  6: '相机动态标定中',
  7: '相机动态标定完成'
});

export const renderWireMotorCalibrationStatus = renderCalibrationStatus({
  0: '未开始',
  1: '标定中',
  2: '标定完成',
  3: '静态标定中',
  4: '静态标定完成',
  5: '动态标定中',
  6: '动态标定传输完成',
  7: '动态标定完成'
});

export const renderBasicCalibrationStatus = renderCalibrationStatus({
  0: '未标定',
  1: '标定成功'
});

export const renderAqiInsCalibrationStatus = renderCalibrationStatus({
  0: '无需标定',
  1: '已收敛',
  2: '未收敛'
});

export const renderAnXingCalibrationStatus = renderCalibrationStatus({
  0: '未知',
  1: '未标定',
  2: '标定中',
  3: '标定完成',
  4: '标定失败',
  5: '自动标定成功',
  6: '自动标定中'
});
